import styled, { css } from 'styled-components';
import { FocusStyles } from '../../../styles/FocusStyles';
import { NoWordWrap } from '../../../styles/NoWordWrap';
import { media } from '../../../components/themes/theme';
const commonFontStyles = css `
  font-kerning: normal;
  letter-spacing: 0.005rem;
  text-rendering: optimizeLegibility;
  line-height: ${props => props.theme.LineHeight};
`;
// This needs to be a Styled Component (https://styled-components.com/docs/advanced#caveat)
// Referring to other components won't work otherwise
export const Accent = styled.em `
  color: ${({ theme, color = 'primary' }) => theme.colors[color]};
  font-family: ${props => props.theme.fonts.accent};
  font-size: inherit;
  font-weight: 400;
  font-style: normal;

  /* Ella font should never wrap or be hyphenated */
  ${NoWordWrap}
`;
export const StyledComponent = styled.p `
  ${commonFontStyles}

  /* Computed styles for Typography */
  color: ${({ theme, $color }) => theme.colors[$color]};
  font-size: ${({ theme, $type, $size }) => theme.typography[$type + $size].fontSize.small};
  font-weight: ${({ $weight }) => $weight};
  font-family: ${({ theme, $fontFamily }) => theme.fonts[$fontFamily]};

  & a {
    color: ${({ $color, theme }) => $color === 'white' ? theme.colors[$color] : theme.colors.primary};
    text-decoration: underline;
    ${FocusStyles};
  }

  /* Typography breakpoints in UiKit are by device class.
   * The only typography-relevant breakpoint is between the "mobile"
   * and the "tablet" class, where the font-size increases. */
  ${media.tablet `
    font-size: ${({ theme, $type, $size }) => theme.typography[$type + $size].fontSize.normal};
  `}

  ${({ $align }) => {
    if ($align) {
        return css `
        text-align: ${$align};
      `;
    }
}}

  ${({ $whiteSpace }) => {
    if ($whiteSpace) {
        return css `
        white-space: ${$whiteSpace};
      `;
    }
}}

  /* Accent styling for headline level 1 and 2 */
  ${({ $color, $size, theme, $type }) => {
    if ($type === 'headline' && $size <= 2) {
        return css `
        ${Accent} {
          color: ${$color === 'white'
            ? theme.colors[$color]
            : theme.colors.primary};
        }
      `;
    }
}}
`;
export const StyledListItemComponent = styled.li `
  ${commonFontStyles}
  /* Obviously "stylelint" does not recognise the selector correctly */
  /* stylelint-disable-next-line selector-type-no-unknown */
  & ${StyledComponent}:last-of-type {
    margin: 0;
    padding: 0;
  }
`;
export const StyledListComponent = styled.ul `
  list-style-type: ${props => (props.$type === 'ordered' ? 'decimal' : 'disc')};
  padding-left: 2ch;

  /* Obviously "stylelint" does not recognise the selector correctly */
  /* stylelint-disable-next-line selector-type-no-unknown */
  & ${StyledListItemComponent}, & ${StyledComponent} {
    font-family: ${({ theme, $fontFamily }) => theme.fonts[$fontFamily]};
    font-weight: ${({ $weight }) => $weight};
    font-size: ${({ theme, $size }) => theme.typography[`copy${$size}`].fontSize.small};

    ${media.tablet `
      font-size: ${({ theme, $size }) => theme.typography[`copy${$size}`].fontSize.normal};
    `}
  }

  ${props => {
    if (props.$type === 'ordered') {
        return css `
        & ol {
          list-style-type: lower-alpha;
          & ol {
            list-style-type: lower-roman;
            & ol {
              list-style-type: disc;
            }
          }
        }
      `;
    }
    return css `
      & ul {
        list-style-type: circle;
        & ul {
          list-style-type: disc;
          & ul {
            list-style-type: circle;
          }
        }
      }
    `;
}}
`;
